package fyi.moko.hotpl.domain.model

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

/**
 * Mints a new [Place.id].
 *
 * A place id doubles as its Firestore document id, so it has to be unique across *devices*, not
 * just within one database. It used to be a local autoincrement row id, which meant two devices
 * independently handed out 1, 2, 3… — an anonymous session's place could collide with an unrelated
 * place the account already owned, and the higher-versioned remote one would silently overwrite it
 * on the next pull. A random UUID makes that impossible by construction.
 *
 * Injected (rather than called inline) so tests can hand out predictable ids.
 */
fun interface PlaceIdGenerator {
    fun newId(): String
}

@OptIn(ExperimentalUuidApi::class)
object RandomPlaceIdGenerator : PlaceIdGenerator {
    override fun newId(): String = Uuid.random().toString()
}
